import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/proposition-bets-widget.module.scss";
import {Image} from "../../../core/components/image/image";
import {BetsImageRequestParams} from "../../../core/icons/bets.image.request-params";

export const PropositionBetsWidgetEmptyState = observer(({controller}) => {
  const {state, terms} = controller;
  const {shouldRenderEmptyState} = state;
  const {WEB_GAME_ODDS_EMPTY_STATE_TEXT} = terms;

  const imageProps = {
    src: new BetsImageRequestParams(),
    className: classNames(styles.empty_state_logo)
  }

  return shouldRenderEmptyState ? <div className={classNames(styles.empty_state)}>
    <Image {...imageProps}/>
    <div className={classNames(styles.empty_state_text)}>{WEB_GAME_ODDS_EMPTY_STATE_TEXT}</div>
  </div> : null
});
